export const projects = [
  {
    id: '1',
    title: 'Modern Kitchen Remodel',
    description: 'Complete kitchen transformation with custom white cabinets, gold hardware, and stunning marble island',
    image: 'https://customer-assets.emergentagent.com/job_homecraft-17/artifacts/0c1g8duh_20251111_191316.jpg',
    category: 'Kitchen Remodeling',
    location: 'Cleveland, OH',
    year: '2024'
  },
  {
    id: '4',
    title: 'Elegant Staircase Renovation',
    description: 'Stunning staircase transformation with custom carpet runner and wrought iron railings',
    image: 'https://customer-assets.emergentagent.com/job_homecraft-17/artifacts/gmecpcp3_Screenshot_20241227_154557_Gallery.jpg',
    category: 'Interior Remodeling',
    location: 'Westlake, OH',
    year: '2024'
  },
  {
    id: '5',
    title: 'Hardwood Flooring Installation',
    description: 'Beautiful hardwood flooring throughout main living areas with custom archway detail',
    image: 'https://customer-assets.emergentagent.com/job_homecraft-17/artifacts/xufj8l3e_IMG_20240528_182457.jpg',
    category: 'Interior Remodeling',
    location: 'Parma, OH',
    year: '2024'
  }
];

export const services = [
  {
    id: '1',
    title: 'Kitchen Remodeling',
    description: 'Transform your kitchen into a beautiful, functional space with expert craftsmanship.',
    image: 'https://images.unsplash.com/photo-1556911220-bff31c812dba',
    features: ['Custom cabinets', 'Countertop installation', 'Modern appliances', 'Complete makeovers']
  },
  {
    id: '2',
    title: 'Bathroom Renovation',
    description: 'Upgrade your bathroom with our comprehensive remodeling services.',
    image: 'https://images.unsplash.com/photo-1552321554-5fefe8c9ef14',
    features: ['Tile work', 'Fixture upgrades', 'Shower & tub installation', 'Modern designs']
  },
  {
    id: '3',
    title: 'Home Additions',
    description: 'Expand your living space with seamless room additions and extensions.',
    image: 'https://images.unsplash.com/photo-1593012671976-1422185230fb',
    features: ['Room additions', 'Second stories', 'Sunrooms', 'Garage conversions']
  },
  {
    id: '4',
    title: 'Basement Finishing',
    description: 'Transform your basement into functional, beautiful living space.',
    image: 'https://images.unsplash.com/photo-1600607687920-4e2a09cf159d',
    features: ['Waterproofing', 'Insulation', 'Drywall & flooring', 'Custom layouts']
  },
  {
    id: '5',
    title: 'Roofing & Siding',
    description: 'Professional roofing and siding services to protect and beautify your home.',
    image: 'https://images.pexels.com/photos/8488023/pexels-photo-8488023.jpeg',
    features: ['Roof replacement', 'Siding installation', 'Repairs', 'Quality materials']
  },
  {
    id: '6',
    title: 'Interior Remodeling',
    description: 'Complete interior renovations tailored to your lifestyle and preferences.',
    image: 'https://images.unsplash.com/photo-1587582423116-ec07293f0395',
    features: ['Flooring installation', 'Painting', 'Trim work', 'Custom finishes']
  }
];

export const reviews = [
  {
    id: '1',
    name: 'Sarah Johnson',
    rating: 5,
    comment: 'BuildBroz did an amazing job remodeling our kitchen. The attention to detail and professionalism was outstanding!',
    project: 'Kitchen Remodel',
    date: '2025-01-15',
    location: 'Cleveland, OH'
  },
  {
    id: '2',
    name: 'Michael Chen',
    rating: 5,
    comment: 'Our bathroom renovation exceeded expectations. The team was professional, on time, and the quality is exceptional.',
    project: 'Bathroom Renovation',
    date: '2025-02-10',
    location: 'Lakewood, OH'
  },
  {
    id: '3',
    name: 'David Martinez',
    rating: 5,
    comment: 'From start to finish, BuildBroz was amazing. They transformed our basement into a beautiful living space!',
    project: 'Basement Finishing',
    date: '2025-01-20',
    location: 'Parma, OH'
  },
  {
    id: '4',
    name: 'Emily Roberts',
    rating: 5,
    comment: 'Highly recommend BuildBroz! Our home addition was completed on schedule and looks fantastic.',
    project: 'Home Addition',
    date: '2025-03-05',
    location: 'Westlake, OH'
  }
];

export const teamMembers = [
  {
    id: '1',
    name: 'Quality Kitchen Work',
    image: 'https://customer-assets.emergentagent.com/job_homecraft-17/artifacts/0c1g8duh_20251111_191316.jpg',
    description: 'Premium kitchen remodeling'
  },
  {
    id: '2',
    name: 'Custom Staircase',
    image: 'https://customer-assets.emergentagent.com/job_homecraft-17/artifacts/gmecpcp3_Screenshot_20241227_154557_Gallery.jpg',
    description: 'Expert staircase renovations'
  },
  {
    id: '3',
    name: 'Flooring Excellence',
    image: 'https://customer-assets.emergentagent.com/job_homecraft-17/artifacts/xufj8l3e_IMG_20240528_182457.jpg',
    description: 'Professional hardwood installation'
  }
];